<template>
  <div>
    <div class="position-relative">
      <!-- shape Hero -->
      <section class="section-shaped my-0">
        <div class="shape shape-style-1 shape-default shape-skew">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
        <div class="container shape-container d-flex">
          <div class="col px-0">
            <div class="row">
              <div class="col-lg-6">
                <h1 class="display-3  text-white">
                  Report
                  <span>Cikarang Ambulans Service</span>
                </h1>
                <p class="lead  text-white">
                  Pelayanan yang telah kami lakukan terdokumentasi dengan baik
                  dalam sebuah laporan tertulis yang akan selalu diupdate secara
                  berkala setiap kami selesai melakukan suatu pelayanan ambulan.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- 1st Hero Variation -->
    </div>
    <section class="section section-lg pt-lg-0 mt--200">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-12">
            <div class="row row-grid">
              <div class="col-lg-12">
                <card class="border-0" shadow body-classes="py-5">
                  <div class="table-responsive-md">
                    <h3 class="text-primary font-weight-light mb-2">
                      Click for detail report!
                    </h3>
                    <!-- start filter -->
                    <div class="row">
                      <div class="col-lg-6 my-3">
                        <b-form-select
                          v-model="selected"
                          :options="options"
                        ></b-form-select>
                      </div>
                      <div class="col-lg-6 my-3">
                        <b-form-select
                          v-model="selected1"
                          :options="options1"
                        ></b-form-select>
                      </div>
                    </div>
                    <!-- end filter -->

                    <!-- <h6><i>*) click for detail report</i></h6> -->
                    <!-- <b-table
                      id="my-table"
                      :items="laporan"
                      :per-page="perPage"
                      :current-page="currentPage"
                      small
                    ></b-table> -->
                    <table class="table caption-top">
                      <thead>
                        <tr>
                          <th scope="col" style="width: 15%;">Tanggal</th>
                          <th scope="col" style="width: 25%;">Status</th>
                          <th scope="col" style="width: 25%;">Penjemputan</th>
                          <th scope="col" style="width: 35%;">Tujuan</th>
                        </tr>
                      </thead>
                      <tbody
                        v-for="item in selected === null && selected1 === null
                          ? laporan
                          : displayLaporan"
                        :key="item"
                        @click="detail(item)"
                      >
                        <tr class="clickable-row">
                          <td>{{ item.tanggal }}</td>
                          <td>{{ item.status }}</td>
                          <td>{{ item.jemput }}</td>
                          <td>{{ item.tujuan }}</td>
                        </tr>
                      </tbody>
                      <!-- <tbody
                        v-for="item in dummy"
                        :key="item"
                        @click="detail(item)"
                      >
                        <tr class="clickable-row">
                          <th scope="row">{{ item.id }}</th>
                          <td>{{ item.tanggal }}</td>
                          <td>{{ item.pasien }}</td>
                          <td>{{ item.unit }}</td>
                        </tr>
                      </tbody> -->
                    </table>
                    <!-- <div>
                      <b-pagination
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                        aria-controls="my-table"
                      ></b-pagination>
                      <base-pagination
                        :x="10"
                        v-model="pagination.default"
                      ></base-pagination>
                    </div> -->
                  </div>
                </card>

                <!-- start pop-up detail report -->
                <modal
                  :show.sync="myModel"
                  body-classes="p-0"
                  modal-classes="modal-dialog-centered modal-lg"
                >
                  <card
                    type="secondary"
                    shadow
                    header-classes="bg-white pb-5"
                    body-classes="px-lg-5 py-lg-5"
                    class="border-0"
                  >
                    <template>
                      <form role="form">
                        <h3
                          slot="header"
                          class="modal-title"
                          id="modal-title-notification"
                        >
                          Service Report
                        </h3>
                        <br />
                        <div class="col-lg">
                          <!-- Tabs with icons -->
                          <tabs fill class="flex-column flex-md-row">
                            <card shadow slot-scope="{ activeTabIndex }">
                              <tab-pane key="tab1">
                                <template slot="title">
                                  <i class="ni ni-cloud-upload-96 mr-2"></i
                                  >Laporan
                                </template>

                                <h6>
                                  FORM LAPORAN GIAT CIKARANG AMBULANS SERVICE
                                </h6>
                                <p>
                                  HARI/TGL : {{ modal.tanggal }} <br />
                                  PENJEMPUTAN : {{ modal.jemput }} <br />
                                  TUJUAN : {{ modal.tujuan }} <br />
                                  <!-- NAMA PASIEN : {{ modal.pasien }} <br />
                                  USIA : +- {{ modal.usia }} TH<br /> -->
                                  STATUS PASIEN : {{ modal.status }} <br />
                                  <!-- UNIT : {{ modal.unit }} <br />
                                  PLAT NO : {{ modal.plat }} <br />
                                  JAM BERANGKAT : {{ modal.jam }} <br />
                                  RUTE : {{ modal.rute }} <br />
                                  PILOT : {{ modal.pilot }} <br />
                                  CO.PILOT : {{ modal.copilot }} -->
                                </p>
                                <p>
                                  _________ <br />
                                  Atas respon dan partisipasi rekan2 relawan
                                  kami ucapkan terimakasih, Semoga tuhan selalu
                                  memberikan berkah & keselamatan untuk kita
                                  semua.
                                </p>
                                <br />
                                <h6>
                                  Bekerja dengan hati, Berbuat dengan ikhlas
                                </h6>
                                <h6>Hormat kami</h6>
                                <p>---------------------</p>
                                <h6>
                                  Cikarang Ambulans Service <br />
                                  Koordinasi Info Ambulance <br />
                                  Perkumpulan Ambulans Cikarang Karawang
                                </h6>
                              </tab-pane>

                              <tab-pane key="tab2">
                                <template slot="title">
                                  <i class="ni ni-bell-55 mr-2"></i>Dokumentasi
                                </template>

                                <b-carousel id="carousel1" controls indicators>
                                  <!-- Text slides with image -->
                                  <b-carousel-slide
                                    v-if="modal.img"
                                    :img-src="modal.img"
                                  ></b-carousel-slide>
                                  <b-carousel-slide
                                    v-if="modal.img1"
                                    :img-src="modal.img1"
                                  ></b-carousel-slide>
                                  <b-carousel-slide
                                    v-if="modal.img2"
                                    :img-src="modal.img2"
                                  ></b-carousel-slide>

                                  <!-- <b-carousel-slide
                                    img-src="img/car/car3.jpg"
                                  ></b-carousel-slide>
                                  <b-carousel-slide
                                    img-src="img/car/car4.jpg"
                                  ></b-carousel-slide>
                                  <b-carousel-slide
                                    img-src="img/car/car5.jpg"
                                  ></b-carousel-slide> -->
                                </b-carousel>
                              </tab-pane>
                            </card>
                          </tabs>
                        </div>
                      </form>
                    </template>
                  </card>
                </modal>
                <!-- end pop-up detail report-->
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="mt-3">
          <h5>
            Isi laporan filter:
          </h5>
          {{ displayLaporan }}
        </div> -->
      </div>
    </section>
  </div>
</template>

<script>
const axios = require("axios");
import Modal from "@/components/Modal.vue";
import Tabs from "@/components/Tabs/Tabs.vue";
import TabPane from "@/components/Tabs/TabPane.vue";

export default {
  components: {
    Modal,
    Tabs,
    TabPane,
  },
  data() {
    return {
      selected: null,
      options: [
        { value: null, text: "All Month" },
        { value: 1, text: "January" },
        { value: 2, text: "February" },
        { value: 3, text: "March" },
        { value: 4, text: "April" },
        { value: 5, text: "May" },
        { value: 6, text: "June" },
        { value: 7, text: "July" },
        { value: 8, text: "August" },
        { value: 9, text: "September" },
        { value: 10, text: "October" },
        { value: 11, text: "November" },
        { value: 12, text: "December" },
      ],
      selected1: null,
      options1: [{ value: null, text: "All Year" }],
      myModel: false,
      modal: "",
      laporan: [
        {
          id: "199",
          tanggal: "2023-02-06",
          jemput: "Perum Setu Perma",
          tujuan: "RS. Hermina Bekasi",
          pasien: "nn",
          usia: "0",
          status: "Pasien Pasca Operasi",
          unit: "",
          plat: "",
          jam: "07:05:00",
          rute: "Darat",
          pilot: "",
          copilot: "",
          cp: "",
          flag: "1",
          img: "upload/1675668814.jpeg",
          img1: "",
          img2: "",
        },
        {
          id: "200",
          tanggal: "2023-02-06",
          jemput: "Cikunir Bekasi Kota",
          tujuan: "RSUP. Fatmawati Jakarta",
          pasien: "nn",
          usia: "0",
          status: "Rujuk Lepas",
          unit: "",
          plat: "",
          jam: "08:25:00",
          rute: "",
          pilot: "",
          copilot: "",
          cp: "",
          flag: "1",
          img: "upload/1675668842.jpeg",
          img1: "",
          img2: "",
        },
        {
          id: "197",
          tanggal: "2023-02-05",
          jemput: "Rs. Metro Hospital",
          tujuan: "Tegal Danas Cikarang",
          pasien: "Nn",
          usia: "0",
          status: "Jenazah",
          unit: "Suozz",
          plat: "",
          jam: "10:03:00",
          rute: "Darat",
          pilot: "",
          copilot: "",
          cp: "",
          flag: "1",
          img: "upload/1675572991.jpg",
          img1: "",
          img2: "",
        },
        {
          id: "198",
          tanggal: "2023-02-05",
          jemput: "RS. Annisa CIkarang",
          tujuan:
            "l. Flamboyan BLOK E. 4 No 1 Reni jaya RT 001/007 DS. Pondok petir Kec. Bojongsari",
          pasien: "nn",
          usia: "0",
          status: "Jenazah",
          unit: "Baby Gemoy",
          plat: "",
          jam: "19:30:00",
          rute: "Tol",
          pilot: "",
          copilot: "",
          cp: "",
          flag: "1",
          img: "upload/1675668691.jpeg",
          img1: "",
          img2: "",
        },
        {
          id: "194",
          tanggal: "2023-02-04",
          jemput: "RS. Cibitung Medika",
          tujuan: "RSPJ. Harapan Kita",
          pasien: "Nn",
          usia: "0",
          status: "Rujuk Lepas",
          unit: "",
          plat: "",
          jam: "09:30:00",
          rute: "full Tol",
          pilot: "",
          copilot: "",
          cp: "",
          flag: "1",
          img: "upload/1675556564.jpg",
          img1: "upload/1675556572.jpg",
          img2: "",
        },
        {
          id: "195",
          tanggal: "2023-02-04",
          jemput: "Perum Lembah Hijau",
          tujuan: "RS. Sentra Medika",
          pasien: "Nn",
          usia: "0",
          status: "Pasien Kontrol ",
          unit: "Suozz",
          plat: "",
          jam: "10:39:00",
          rute: "Darat",
          pilot: "",
          copilot: "",
          cp: "",
          flag: "1",
          img: "upload/1675556739.jpg",
          img1: "",
          img2: "",
        },
        {
          id: "196",
          tanggal: "2023-02-04",
          jemput: "Lasar Beras Cikarang",
          tujuan: "RS. Harapan Keluarga",
          pasien: "Nn",
          usia: "0",
          status: "Ibu melahirkan",
          unit: "Gemoy",
          plat: "",
          jam: "23:05:00",
          rute: "Darat",
          pilot: "",
          copilot: "",
          cp: "",
          flag: "1",
          img: "upload/1675556826.jpg",
          img1: "",
          img2: "",
        },
        {
          id: "192",
          tanggal: "2023-02-02",
          jemput: "Mareleng",
          tujuan: "RS. Annisa CIkarang",
          pasien: "nn",
          usia: "0",
          status: "Pasien Kontrol",
          unit: "Fadillah",
          plat: "",
          jam: "15:20:00",
          rute: "Darat",
          pilot: "",
          copilot: "",
          cp: "",
          flag: "1",
          img: "upload/1675331708.jpeg",
          img1: "",
          img2: "",
        },
        {
          id: "193",
          tanggal: "2023-02-02",
          jemput: "Perum Taman Permata Indah",
          tujuan: "RS. Siloam Semanggi",
          pasien: "nn",
          usia: "0",
          status: "Pasien Drop-IGD",
          unit: "Baby Gemoy",
          plat: "",
          jam: "23:00:00",
          rute: "Tol",
          pilot: "",
          copilot: "",
          cp: "",
          flag: "1",
          img: "upload/1675331977.jpeg",
          img1: "",
          img2: "",
        },
        {
          id: "191",
          tanggal: "2023-01-22",
          jemput: "Gramapuri",
          tujuan: "TPU Wangkal Jati",
          pasien: "Nn",
          usia: "0",
          status: "Jenazah",
          unit: "Naby suozz",
          plat: "B1503NKK",
          jam: "09:40:00",
          rute: "Darat",
          pilot: "Demplang",
          copilot: "Enung",
          cp: "",
          flag: "1",
          img: "upload/1674356776.jpg",
          img1: "",
          img2: "",
        },
        {
          id: "188",
          tanggal: "2023-01-19",
          jemput: "RS. Annisa Cikarang",
          tujuan: "RSUD Cibitung",
          pasien: "nn",
          usia: "0",
          status: "Pasien Rujuk Lepas",
          unit: "Baby Suozz",
          plat: "B1503NKK",
          jam: "23:22:00",
          rute: "Darat",
          pilot: "Demplang",
          copilot: "Budi",
          cp: "",
          flag: "1",
          img: "upload/1674177165.jpeg",
          img1: "upload/1674177210.jpeg",
          img2: "",
        },
        {
          id: "189",
          tanggal: "2023-01-19",
          jemput: "RS. Radjak Purwakarta",
          tujuan: "RSUD Azhari, Pemalang",
          pasien: "Tn. Radjak",
          usia: "0",
          status: "Pasien Rujuk",
          unit: "Baby Gemoy",
          plat: "",
          jam: "18:31:00",
          rute: "Tol",
          pilot: "Kevin",
          copilot: "Heri",
          cp: "",
          flag: "1",
          img: "upload/1674177328.jpeg",
          img1: "upload/1674177406.jpeg",
          img2: "",
        },
        {
          id: "190",
          tanggal: "2023-01-19",
          jemput: "Cikarang Kota",
          tujuan: "TPU Kp. Kongsi Buniasih",
          pasien: "nn",
          usia: "0",
          status: "Jenazah",
          unit: "Baby Suozz",
          plat: "B1503NkKK",
          jam: "17:05:00",
          rute: "Darat",
          pilot: "Demplang",
          copilot: "Hj. Mansur",
          cp: "",
          flag: "1",
          img: "",
          img1: "",
          img2: "",
        },
        {
          id: "187",
          tanggal: "2023-01-18",
          jemput: "Pasar bersih cikarang",
          tujuan: "Rs. Karya medika 1",
          pasien: "Nn",
          usia: "0",
          status: "Pasien ",
          unit: "Suozz",
          plat: "B1503NKK",
          jam: "20:00:00",
          rute: "Darat",
          pilot: "Heri",
          copilot: "Kevin",
          cp: "",
          flag: "1",
          img: "upload/1674049833.jpg",
          img1: "upload/1674049847.jpg",
          img2: "",
        },
        {
          id: "186",
          tanggal: "2023-01-16",
          jemput: "GCC Cikarang",
          tujuan: "RSCM Jakarta",
          pasien: "nn",
          usia: "0",
          status: "Pasien Kontrol",
          unit: "Baby Gemoy",
          plat: "",
          jam: "10:00:00",
          rute: "Toll",
          pilot: "Kevin",
          copilot: "Demplang",
          cp: "",
          flag: "1",
          img: "upload/1673844343.jpeg",
          img1: "upload/1673844366.jpeg",
          img2: "",
        },
        {
          id: "184",
          tanggal: "2023-01-08",
          jemput: "Perum Puri Cikarang Indah",
          tujuan: "RSCM Jakarta",
          pasien: "nn",
          usia: "0",
          status: "Pasien Kalasenia",
          unit: "Suozz",
          plat: "B1503NKK",
          jam: "21:12:00",
          rute: "Full Toll",
          pilot: "Heri",
          copilot: "Budi",
          cp: "",
          flag: "1",
          img: "upload/1673241749.jpeg",
          img1: "upload/1673241761.jpeg",
          img2: "",
        },
        {
          id: "183",
          tanggal: "2023-01-06",
          jemput: "GCC Cikarang",
          tujuan: "RSCM Jakarta",
          pasien: "nn",
          usia: "0",
          status: "Pasien Poli",
          unit: "Suozz",
          plat: "B2503NKK",
          jam: "08:30:00",
          rute: "Full Toll",
          pilot: "Demplang",
          copilot: "Budi",
          cp: "",
          flag: "1",
          img: "upload/1672993704.jpeg",
          img1: "",
          img2: "",
        },
        {
          id: "181",
          tanggal: "2022-12-18",
          jemput: "Kp. Bulu",
          tujuan: "TPU Papan Mas",
          pasien: "",
          usia: "0",
          status: "Jenazah",
          unit: "Gemoy",
          plat: "B2787FKJ",
          jam: "09:43:00",
          rute: "Darat",
          pilot: "Kevin",
          copilot: "Ibra",
          cp: "",
          flag: "1",
          img: "upload/1671331417.jpg",
          img1: "",
          img2: "",
        },
        {
          id: "180",
          tanggal: "2022-12-17",
          jemput: "Telaga pesona",
          tujuan: "Rs. Karya medika 1",
          pasien: "",
          usia: "0",
          status: "Pasien cuci darah",
          unit: "Gemoy",
          plat: "B2787FKJ",
          jam: "00:00:00",
          rute: "Darat",
          pilot: "Kevin",
          copilot: "",
          cp: "",
          flag: "1",
          img: "upload/1671237056.jpg",
          img1: "",
          img2: "",
        },
        {
          id: "182",
          tanggal: "2022-12-17",
          jemput: "Rs. Sentra Medika",
          tujuan: "Adipala Cilacal",
          pasien: "",
          usia: "0",
          status: "Jenazah",
          unit: "Gemoy",
          plat: "B2787FKJ",
          jam: "09:49:00",
          rute: "Full Tol",
          pilot: "Kevin",
          copilot: "Ibra",
          cp: "",
          flag: "1",
          img: "upload/1671331825.jpg",
          img1: "",
          img2: "",
        },
        {
          id: "149",
          tanggal: "2022-12-16",
          jemput: "Tambun Selatan",
          tujuan: "RS. Dharmais",
          pasien: "",
          usia: "0",
          status: "Pasien Kontrol",
          unit: "Suozz",
          plat: "B1503NKK",
          jam: "00:00:00",
          rute: "Full Tol",
          pilot: "Zaenal",
          copilot: "",
          cp: "",
          flag: "1",
          img: "upload/1671165745.jpeg",
          img1: "upload/1671165757.jpeg",
          img2: "upload/1671165769.jpeg",
        },
        {
          id: "179",
          tanggal: "2022-12-16",
          jemput: "Cikarang Jati Pasar",
          tujuan: "RS. Harapan Keluarga",
          pasien: "",
          usia: "0",
          status: "Pasien",
          unit: "Gemoy",
          plat: "B2787FKJ",
          jam: "11:40:00",
          rute: "Pantura",
          pilot: "Kevin",
          copilot: "",
          cp: "",
          flag: "1",
          img: "upload/1671166602.jpeg",
          img1: "",
          img2: "",
        },
        {
          id: "150",
          tanggal: "2022-12-15",
          jemput: "RS. Amanda Cikarang",
          tujuan: "RSUD Cibitung",
          pasien: "",
          usia: "0",
          status: "Pasien Rujukan",
          unit: "Suozz",
          plat: "B1503NKK",
          jam: "18:00:00",
          rute: "Full Darat",
          pilot: "Zaenal",
          copilot: "Heri",
          cp: "",
          flag: "1",
          img: "",
          img1: "",
          img2: "",
        },
        {
          id: "151",
          tanggal: "2022-12-15",
          jemput: "RS. Karya Medika 1",
          tujuan: "Perum Telaga Pesona",
          pasien: "",
          usia: "0",
          status: "Kepulangan Pasien",
          unit: "Gemoy",
          plat: "B2787FKJ",
          jam: "16:34:00",
          rute: "Full Darat",
          pilot: "Kevin",
          copilot: "",
          cp: "",
          flag: "1",
          img: "",
          img1: "",
          img2: "",
        },
        {
          id: "152",
          tanggal: "2022-12-14",
          jemput: "Pangulah-Cikampek",
          tujuan: "RS. Paru Jatisari",
          pasien: "",
          usia: "0",
          status: "Laka Lantas",
          unit: "Suozz",
          plat: "B1503NKK",
          jam: "00:00:00",
          rute: "Full Darat",
          pilot: "Zaenal",
          copilot: "Ibra",
          cp: "",
          flag: "1",
          img: "",
          img1: "",
          img2: "",
        },
        {
          id: "153",
          tanggal: "2022-12-13",
          jemput: "Cipinang",
          tujuan: "Tegal",
          pasien: "",
          usia: "0",
          status: "Jenazah",
          unit: "Suozz",
          plat: "B1503NKK",
          jam: "17:30:00",
          rute: "Full Tol",
          pilot: "Zaenal",
          copilot: "Ibra",
          cp: "",
          flag: "1",
          img: "",
          img1: "",
          img2: "",
        },
        {
          id: "154",
          tanggal: "2022-12-12",
          jemput: "RS. Medirossa Cikarang",
          tujuan: "Perum KSB Cikarang Selatan",
          pasien: "",
          usia: "0",
          status: "Kepulangan Pasien",
          unit: "Suozz",
          plat: "B1503NKK",
          jam: "16:00:00",
          rute: "Full Darat",
          pilot: "Zaenal",
          copilot: "Budi",
          cp: "",
          flag: "1",
          img: "",
          img1: "",
          img2: "",
        },
        {
          id: "155",
          tanggal: "2022-12-12",
          jemput: "Kp. Mareleng, Cikarang",
          tujuan: "RS. Harapan Keluarga",
          pasien: "",
          usia: "0",
          status: "Pasien Kontrol",
          unit: "Suozz",
          plat: "B1503NKK",
          jam: "00:00:00",
          rute: "Full Darat",
          pilot: "Zaenal",
          copilot: "Budi",
          cp: "",
          flag: "1",
          img: "",
          img1: "",
          img2: "",
        },
        {
          id: "156",
          tanggal: "2022-12-11",
          jemput: "Cikarang",
          tujuan: "Cianjur, Cigeunang",
          pasien: "",
          usia: "0",
          status: "Donasi Gempa Cianjur",
          unit: "Suozz",
          plat: "B1503NKK",
          jam: "21:00:00",
          rute: "Full Darat",
          pilot: "Demplang",
          copilot: "",
          cp: "",
          flag: "1",
          img: "",
          img1: "",
          img2: "",
        },
        {
          id: "157",
          tanggal: "2022-12-10",
          jemput: "Cikarang",
          tujuan: "Cianjur, Sukamulya",
          pasien: "",
          usia: "0",
          status: "Donasi Gempa Cianjur",
          unit: "Gemoy",
          plat: "B2787FKJ",
          jam: "21:10:00",
          rute: "Full Darat",
          pilot: "Kevin",
          copilot: "Budi",
          cp: "",
          flag: "1",
          img: "",
          img1: "",
          img2: "",
        },
        {
          id: "158",
          tanggal: "2022-12-10",
          jemput: "RS. Cibitung Medika",
          tujuan: "Kp. Tebet",
          pasien: "",
          usia: "0",
          status: "Kepulangan Pasien",
          unit: "Suozz",
          plat: "B1503NKK",
          jam: "18:00:00",
          rute: "Full Darat",
          pilot: "Demplang",
          copilot: "",
          cp: "",
          flag: "1",
          img: "",
          img1: "",
          img2: "",
        },
        {
          id: "159",
          tanggal: "2022-12-10",
          jemput: "RSUD Kota Bekasi",
          tujuan: "Asrama Brigif",
          pasien: "",
          usia: "0",
          status: "Jenazah",
          unit: "Suozz",
          plat: "B1503NKK",
          jam: "12:00:00",
          rute: "Full Darat",
          pilot: "Zaenal",
          copilot: "Budi",
          cp: "",
          flag: "1",
          img: "",
          img1: "",
          img2: "",
        },
        {
          id: "160",
          tanggal: "2022-12-10",
          jemput: "Asrama Brigif",
          tujuan: "RSUD Cibitung",
          pasien: "",
          usia: "0",
          status: "Pasien Kontrol",
          unit: "Suozz",
          plat: "B1503NKK",
          jam: "08:00:00",
          rute: "Full Darat",
          pilot: "Zaenal",
          copilot: "Budi",
          cp: "",
          flag: "1",
          img: "",
          img1: "",
          img2: "",
        },
      ],
      // pagination: {
      //   default: 1,
      //   danger: 3,
      // },
      // perPage: 2,
      // currentPage: 1,
      // dummy: [
      //   {
      //     id: "1",
      //     tanggal: "12345",
      //     pasien: "JOKO",
      //     unit: "001",
      //   },
      //   {
      //     id: "2",
      //     tanggal: "78901",
      //     pasien: "TONO",
      //     unit: "004",
      //   },
      // ],
    };
  },
  computed: {
    rows() {
      return this.laporan.length;
    },
    displayLaporan() {
      if (this.selected && this.selected1) {
        return this.laporan.filter(
          (item) =>
            parseInt(item.tanggal.substr(5, 2)) === this.selected &&
            item.tanggal.substr(0, 4) === this.selected1
        );
      } else if (this.selected) {
        return this.laporan.filter(
          (item) => parseInt(item.tanggal.substr(5, 2)) === this.selected
        );
      } else if (this.selected1) {
        return this.laporan.filter(
          (item) => item.tanggal.substr(0, 4) === this.selected1
        );
      }
    },
  },
  methods: {
    setYear() {
      for (var i = new Date().getFullYear(); i > 2020; i--) {
        this.options1.push({ value: `${i}`, text: `${i}` });
      }
    },
    detail(itemModal) {
      this.modal = itemModal;
      this.myModel = true;
    },
    fetchAllData: function() {
      let self = this;

      axios
        .post("action.php", {
          action: "report",
        })
        .then(function(response) {
          self.laporan = response.data;
        });
    },
  },
  created: function() {
    let self = this;

    self.setYear();
    self.fetchAllData();
  },
};
</script>

<style scoped>
tbody tr:active {
  background-color: rgb(133, 152, 242);
  color: white;
}

tbody tr {
  cursor: pointer;
}

tbody tr:hover {
  background-color: rgb(133, 152, 242);
  color: white;
}
</style>
